import { Controller, useFormContext } from "react-hook-form";
import { Input, InputProps } from "@heroui/react";
import { roundTo } from "@/lib/utils/numbers";
import { useRef } from "react";

function TextInput({
    name,
    onAutosave,
    hideErrorMessage,
    decimalPlaces,
    ...props
}: {
    name: string;
    onAutosave?: () => void;
    hideErrorMessage?: boolean;
    decimalPlaces?: number;
} & InputProps) {
    const f = useFormContext();
    const inputRef = useRef<string | null>(null);
    return (
        <Controller
            name={name}
            control={f.control}
            render={({
                fieldState: { error, invalid },
                field: { onBlur, onChange, value },
            }) => {
                return (
                    <Input
                        {...props}
                        isInvalid={invalid}
                        errorMessage={
                            hideErrorMessage ? undefined : error?.message
                        }
                        onFocus={() => {
                            inputRef.current = value;
                        }}
                        onBlur={() => {
                            onBlur();
                            if (inputRef.current !== value && onAutosave)
                                onAutosave();
                        }}
                        color={invalid ? "danger" : "default"}
                        onChange={(e) => {
                            onChange(e);
                            props.onChange?.(e);
                        }}
                        value={
                            props.type === "number"
                                ? decimalPlaces
                                    ? roundTo(Number(value), decimalPlaces)
                                    : value
                                : value
                        }
                    />
                );
            }}
        />
    );
}

export default TextInput;
